// Shared Motion presets — one easing and rhythm across the whole site.
export const EASE = [0.16, 1, 0.3, 1]; // matches --ease-out in tokens.css

export const fadeUp = {
  hidden: { opacity: 0, y: 28 },
  show: { opacity: 1, y: 0, transition: { duration: 0.8, ease: EASE } },
};

export const fadeIn = {
  hidden: { opacity: 0 },
  show: { opacity: 1, transition: { duration: 0.8, ease: EASE } },
};

export const scaleIn = {
  hidden: { opacity: 0, scale: 0.94 },
  show: { opacity: 1, scale: 1, transition: { duration: 0.7, ease: EASE } },
};

export const stagger = (gap = 0.08, delay = 0) => ({
  hidden: {},
  show: { transition: { staggerChildren: gap, delayChildren: delay } },
});

// Spread onto any motion element to animate once when scrolled into view.
export const inView = {
  initial: "hidden",
  whileInView: "show",
  viewport: { once: true, amount: 0.2 },
};

export const hoverLift = {
  whileHover: { y: -3 },
  whileTap: { scale: 0.97, y: 0 },
  transition: { type: "spring", stiffness: 400, damping: 25 },
};
